<template>
  <div>
    <footpc v-if='onlinestate=="pc"'></footpc>
    <footmodel v-else></footmodel>
  </div>
</template>

<script>
  import footpc from './foot_pc.vue'
  import footmodel from './foot_model.vue'
  
  export default{
    components:{footpc,footmodel},
    data(){
      return{
        islang : window.localStorage.guanwanglang,
        onlinestate:sessionStorage['onlinestate']
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/foot/foot.vue